import PropTypes from 'prop-types'
import React, { Component } from 'react'
import classnames from 'classnames'
import { navigate } from 'react-big-calendar/lib/utils/constants'

import { toolbar } from './styles'
import Button from '../../controls/Button'

class Toolbar extends Component {
  static propTypes = {
    view: PropTypes.string.isRequired,
    views: PropTypes.arrayOf(PropTypes.string).isRequired,
    label: PropTypes.node.isRequired,
    messages: PropTypes.object,
    onNavigate: PropTypes.func.isRequired,
    onViewChange: PropTypes.func.isRequired
  }

  render() {
    let { messages, label } = this.props

    return (
      <div className={classnames('rbc-toolbar', 'toolbar')}>
        <span
          className={classnames('rbc-btn-group', 'btn-container', 'navigation')}
        >
          <Button
            color="secondary"
            className="btn"
            outline
            size="small"
            onClick={this.navigate.bind(null, navigate.PREVIOUS)}
          >
            <span className="btn-text">{messages.previous}</span>
          </Button>
          <Button
            color="secondary"
            className="btn"
            outline
            size="small"
            onClick={this.navigate.bind(null, navigate.NEXT)}
          >
            <span className="btn-text">{messages.next}</span>
          </Button>
        </span>
        <span className="rbc-toolbar-label">{label}</span>
        <span
          className={classnames(
            'rbc-btn-group',
            'btn-container',
            'view-selector'
          )}
        >
          {this.viewNamesGroup(messages)}
        </span>
        <style jsx>{toolbar}</style>
      </div>
    )
  }

  navigate = action => {
    this.props.onNavigate(action)
  }

  view = view => {
    this.props.onViewChange(view)
  }

  viewNamesGroup = messages => {
    let viewNames = this.props.views
    const view = this.props.view

    return viewNames.map(name => (
      <Button
        className={classnames('btn', `view-${name}`, {
          'rbc-active': view === name
        })}
        color={view === name ? 'primary' : 'secondary'}
        key={name}
        size="small"
        outline={view !== name}
        onClick={this.view.bind(null, name)}
      >
        <span className="btn-text">{messages[name]}</span>
      </Button>
    ))
  }
}

export default Toolbar
